import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemIntro } from './components/ProblemIntro';
import { RoadmapSteps } from './components/RoadmapSteps';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Toolkit } from './components/Toolkit';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-brand-950" data-id="element-0" data-mp="23t8iki3g6pf1">
      <MetaPixel data-id="element-1" data-mp="3ijpef4c7z5bc" />
      <Hero data-id="element-2" data-mp="3ii4ppvcl6gle" />
      <main data-id="element-3" data-mp="3mlaxx8j9ehui">
        <ProblemIntro data-id="element-4" data-mp="3ml17jjuay8oa" />
        <RoadmapSteps data-id="element-5" data-mp="3mk852v2dm5by" />
        <BeforeAfter data-id="element-6" data-mp="3mjpyp5m02aqb" />
        <PainPoints data-id="element-7" data-mp="3rc9e8848zfxr" />
        <Volumes data-id="element-8" data-mp="3rbrbqtqzs5he" />
        <Toolkit data-id="element-9" data-mp="3rdar8i4tqci4" />
        <Bonuses data-id="element-10" data-mp="3rcswxr1q28cu" />
        <Offer data-id="element-11" data-mp="3reccfffk0fdk" />
        <Guarantee data-id="element-12" data-mp="5yimri0b7dt" />
        <Testimonials data-id="element-13" data-mp="6hq1ea16ddl" />
        <Author data-id="element-14" data-mp="4n4pyuukj8z" />
        <FAQ data-id="element-15" data-mp="56nfhsbnbo2" />
        <FinalCTA data-id="element-16" data-mp="82jf0klzq9v" />
      </main>
      <Footer data-id="element-17" data-mp="2zld43f9knpe6" />
      <FloatingCTA data-id="element-18" data-mp="2zlv8x0aavbxp" />
      <PurchasePopup data-id="element-19" data-mp="2zmemk4sx3e5x" />
    </div>;
}